import { routeHref } from "../routes.js";
import { Icon, type IconName } from "./icons.js";

type GuestTab = "camera" | "galeria" | "album";

const TABS: readonly (readonly [GuestTab, string, IconName])[] = [
  ["camera", "Câmera", "camera"],
  ["galeria", "Galeria", "images"],
  ["album", "Álbum", "grid"],
];

export interface GuestNavProps {
  readonly active: GuestTab;
  readonly onPhoto?: boolean;
}

export function GuestNav({ active, onPhoto = false }: GuestNavProps) {
  return (
    <nav class={onPhoto ? "d-nav is-on-photo" : "d-nav"} aria-label="Navegação">
      <div class="d-nav-pill">
        {TABS.map(([tab, label, icon]) => (
          <a
            key={tab}
            class="d-nav-item"
            href={routeHref(tab)}
            aria-current={tab === active ? "page" : undefined}
          >
            <Icon name={icon} size={16} />
            {label}
          </a>
        ))}
      </div>
    </nav>
  );
}
